import React, { useEffect } from 'react';
import instagramIcon from 'assets/img/instagram.png';
import backIcon from 'assets/img/back.png';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            const headerTitle = document.querySelector('h1#header-title');
            if (headerTitle) {
                headerTitle.classList.toggle('opacity-100', window.scrollY > 100);
                headerTitle.classList.toggle('opacity-0', window.scrollY < 100);
            }
        };

        window.addEventListener('scroll', handleScroll);
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header className="flex justify-between items-center mb-6 fixed top-0 left-0 right-0 px-[42px] h-[46px] pl-[32px] bg-pink-100 z-[100]">
            <div className="flex items-center text-lg justify-left">
                {location.pathname !== "/" && (
                    <button
                        className="text-xl top-0 left-0 w-[40px] h-[40px] -ml-[32px] mr-[26px] -mt-[6px] flex items-center justify-center border border-black"
                        onClick={() => navigate('/')}
                    >
                        <img src={backIcon} alt="go back button" className="w-5 h-5" />
                    </button>
                )}
                <a href="https://www.instagram.com/lekink_/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <img src={instagramIcon} className="max-w-[30px]" />
                </a>
                <h1
                className={`text-lg sm:text-xl font-bold transition-opacity ml-[26px] duration-300 ${
                    window.scrollY > 100 ? 'opacity-100' : 'opacity-0'
                }`} id="header-title"
            >
                Le Kink
            </h1>
            </div>

            {/*  <Link to="/about" className="sm:text-base underline"> About </Link>  */}
        </header>
    );
};

export default Header;